import { z } from "zod";
import { isCalendarDate } from "../utils/calendar-date";

export const calendarDateSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, "Date must be YYYY-MM-DD")
  .refine(isCalendarDate, "Date must be a valid calendar date");
